import axios from "axios";
import { get_object_from_storage, obj_to_querystring, patch_object_on_storage } from "../utils";
import popupAlerts from "../core/popupAlerts";
import _ from "lodash";

let token = "", _auth_callback;

export default class Api {

    async api(method, endPoint, additionalOptions = {}) {
        try {
            this.baseURL = '/api';

            const url = this.prefix === '' ? endPoint : `/${this.prefix}${endPoint ? endPoint : ''}`;

            const options = Object.assign({ method, url: this.baseURL + url }, additionalOptions);

            const _api = axios.create({ timeout: 5000 });

            _api.interceptors.request.use(
                config => {
                    if (!config.headers.Authorization) config.headers = _.merge(config.headers, this.headers);
                    return config;
                },
                error => {
                    return Promise.reject(error);
                }
            );


            return await _api(options);
        } catch (e) {
            if (e.response && e.response?.data && e.response?.data?.status == "unauthorized") {

                _auth_callback && _auth_callback({ is_logged: false });

                popupAlerts.warning("Faça login para continuar!");

            } else error_handler(e)

            return Promise.reject(e);
        };
    };

    get(query_obj, params = []) {
        return this.api('get', `${params.length ? '/' + params.join('/') : ''}${query_obj ? obj_to_querystring(query_obj) : ''}`);
    };

    create(body = {}) {
        return this.api('post', '', { data: body });
    };

    update(body = {}, id) {
        return this.api('put', '/' + id, { data: body });
    };

    delete(id) {
        return this.api('delete', "/" + id);
    };


    get token() {
        try {
            if (token) return token;

            const ls = get_object_from_storage("user_data");

            if (!ls) return "";

            return ls.token;
        } catch (e) {
            return "";
        };
    };

    get headers() {
        const headers = {};
        headers.Authorization = `Bearer ${this.token}`;
        return headers;
    };
};

export function auth_service_callback(callback) {
    _auth_callback = callback;
};

export async function log_in(body) {
    try {
        const { data } = await axios.post("/api/login", body, { timeout: 5000 });

        patch_object_on_storage("user_data", { token: data.token, username: data.username });

        token = data.token;

        _auth_callback && _auth_callback({ is_logged: true });

        popupAlerts.success("Login efetuado com sucesso");
    } catch (e) {
        error_handler(e);
    };
};

function error_handler(e) {
    if (e.response && e.response?.data) {
        const data = e.response.data;

        if (data.message) popupAlerts.danger(data.message);

        if (data.messages) popupAlerts.danger(data.messages[0]?.message);
    } else {
        if (e.code == "ERR_NETWORK") popupAlerts.danger("Erro de conexão!");
    };
};